import React, { useEffect } from "react";
import { Separator } from "../../ui/separator";

const Jurisdiction = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex-grow bg-white py-8 md:py-12">
      <div className="container mx-auto px-2 md:px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-8 md:mb-12">
            <h1 className="text-3xl font-bold mb-6 text-center text-[#2D0052]">
              Jurisdiction & Governing Law Notice
            </h1>
            <p className="text-sm text-gray-500 text-center mb-8">
              Last updated: Jun 02, 2025
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                1. What This Section Covers
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                This section explains:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Which country's laws apply when you use Oye Creators.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Where any lawsuit or arbitration must be filed.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  What steps you and we must follow before going to court or
                  arbitrator.
                </li>
              </ul>

              <p className="text-base leading-relaxed text-gray-800 mt-4 mb-4">
                It applies equally to all three types of users on our
                platform:
              </p>
              <ol className="list-decimal ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Brands & Businesses that post campaigns ("Gigs")
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Creators who perform those Gigs once selected
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Oye Creators (TTL Media Pvt. Ltd.) as the platform operator
                </li>
              </ol>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                2. Governing Law: India First, International Second
              </h2>
              <ol className="list-decimal ml-6 space-y-4">
                <li className="text-base leading-relaxed text-gray-800">
                  <span className="font-medium">Primary Law:</span> All terms
                  and disputes are governed by the laws of India, including
                  but not limited to:
                  <ul className="list-disc ml-6 mt-2 space-y-2">
                    <li className="text-base leading-relaxed text-gray-800">
                      The Indian Contract Act, 1872 (your agreement to these
                      terms)
                    </li>
                    <li className="text-base leading-relaxed text-gray-800">
                      The Arbitration & Conciliation Act, 1996 (if we
                      arbitrate)
                    </li>
                    <li className="text-base leading-relaxed text-gray-800">
                      The Information Technology Act, 2000 (online
                      communications and data)
                    </li>
                  </ul>
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <span className="font-medium">International Law:</span> If
                  there are mandatory rules under international treaties or
                  conventions (e.g., for cross-border data), those also
                  apply—but only to the extent they cannot be overridden by
                  private agreement.
                </li>
              </ol>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                3. Definitions & Scope of "Dispute"
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                "Dispute" or "Claim" means any disagreement, complaint, or
                demand arising out of or relating to:
              </p>
              <ol className="list-decimal ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Your use of the platform (e.g., a Creator not getting paid)
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Any campaign, contract, or content delivered
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Interpretation of these terms themselves
                </li>
              </ol>

              <p className="text-base leading-relaxed text-gray-800 mt-4 mb-4">
                <span className="font-medium">Excluded Matters:</span>{" "}
                Personal injury, death, or intellectual property infringement
                claims may proceed directly in court.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                4. Try to Resolve Things Informally First
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                Before filing a lawsuit or arbitration:
              </p>
              <ol className="list-decimal ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Send us a written notice explaining your issue in reasonable
                  detail.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Email to: legal@oyecreators.com
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Postal address: TTL Media Pvt. Ltd., [Registered Office],
                  Pune, Maharashtra 411001, India
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  30-Day Window: We both agree to discuss in good faith for up
                  to 30 days. If we can't settle, then proceed as below.
                </li>
              </ol>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                5. Your Options: Court or Arbitration
              </h2>
              <div className="mb-4">
                <h3 className="text-lg font-medium mb-3">
                  A. Court Proceedings
                </h3>
                <ul className="list-disc ml-6 space-y-2">
                  <li className="text-base leading-relaxed text-gray-800">
                    Where: Courts in Pune, Maharashtra, India
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Why Pune? That's where our headquarters sit—so it's fair
                    and predictable.
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    How: File your suit at the appropriate Pune court (e.g.,
                    the City Civil Court or District Court, depending on the
                    claim amount).
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-3">
                  B. Arbitration (Our Option)
                </h3>
                <ul className="list-disc ml-6 space-y-2">
                  <li className="text-base leading-relaxed text-gray-800">
                    Seat (Legal Home): Pune, Maharashtra, India
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Rules: Arbitration & Conciliation Act, 1996
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Arbitrator: One sole arbitrator, mutually agreed or
                    appointed by the Pune branch of the Indian Council of
                    Arbitration
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Language: English
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Procedure Highlights:
                    <ol className="list-decimal ml-6 mt-2 space-y-2">
                      <li className="text-base leading-relaxed text-gray-800">
                        Notice of Arbitration: Written demand specifying your
                        claim and relief sought
                      </li>
                      <li className="text-base leading-relaxed text-gray-800">
                        Timetable: Hearing within 6 months of arbitrator
                        appointment (unless parties agree otherwise)
                      </li>
                      <li className="text-base leading-relaxed text-gray-800">
                        Award: Final and binding, enforceable like a court
                        judgment
                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                6. Waiver of Class Actions
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                You and we each give up the right to participate in any class,
                collective, or representative action or arbitration. Keeps
                proceedings simpler and ensures fairness for small disputes.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                7. Costs & Fees
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Court: Each party bears its own lawyer's fees, unless the
                  court orders otherwise.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Arbitration: The losing party typically pays the
                  arbitrator's fees and related administrative costs, unless
                  the arbitrator allocates them differently.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                8. Severability
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                If any single part of this section is found unenforceable
                (e.g., a specific time limit), the rest remains in force.
                We'll replace the invalid part with something as close as
                possible to the original intent.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                9. No Waiver
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                If we don't enforce a right right away (e.g., we delay suing
                you for non-payment), that doesn't mean we give up that right
                forever.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                10. Updates & Your Continued Use
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                We may change this notice from time to time. Look at the "Last
                updated" date at the top of our Terms. By continuing to use
                Oye Creators after a change, you accept the new rules.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                11. Indemnification
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                To the fullest extent permitted by law, you agree to
                indemnify, defend, and hold harmless TTL Media Pvt. Ltd. ("Oye
                Creators"), its affiliates, and each of their officers,
                directors, employees, agents, successors, and assigns
                (collectively, the "Indemnitees") from and against any and all
                claims, demands, losses, liabilities, damages, costs, and
                expenses (including reasonable attorneys' fees) made by any
                third party due to or arising out of:
              </p>
              <ol className="list-decimal ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Your breach or alleged breach of these terms or any
                  representation or warranty herein;
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Your violation of any law or the rights of a third party
                  (e.g., intellectual property infringement or privacy
                  violations);
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Your misuse of the platform, including but not limited to
                  content you post, campaigns you run or participate in, and
                  any promoters or bots you employ.
                </li>
              </ol>

              <p className="text-base leading-relaxed text-gray-800 mt-4 mb-4">
                We reserve the right, at our own expense, to assume the
                exclusive defense and control of any matter otherwise subject
                to indemnification by you. In such case, you agree to
                cooperate with our defense of such claim.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#D9008D]">
                Plain English Summary
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Law: Indian law (plus any essential international rules).
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Where: Pune courts, or arbitration in Pune if we pick that
                  route.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  First Step: Write to legal@oyecreators.com and give us 30
                  days to fix it.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Solo Play: No group lawsuits—only individual claims.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Indemnification: You cover us if a third party sues over
                  your breach or content.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Fairness Guarantee: If any piece is struck down, everything
                  else still works.
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Jurisdiction
